import { trackEvent } from '../analytics';

function Footer() {
  const handleLinkClick = (linkType) => {
    trackEvent('footer_link_clicked', {
      link_type: linkType,
    });
  };

  return (
    <footer
      className="border-t border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900 px-6 py-10 sm:px-8 sm:py-12 md:px-12 transition-colors duration-200"
      role="contentinfo"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 text-center">
        <div className="flex flex-wrap items-center justify-center gap-6">
          <a
            href="https://www.linkedin.com/in/elizabethblege"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleLinkClick('linkedin')}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-gray-600 dark:text-gray-400 transition-colors hover:text-primary-500 dark:hover:text-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
            aria-label="LinkedIn"
          >
            <svg
              className="h-6 w-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden
            >
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
          <a
            href="mailto:hello@elizabethblege.com"
            onClick={() => handleLinkClick('email')}
            className="flex h-10 w-10 items-center justify-center rounded-lg text-gray-600 dark:text-gray-400 transition-colors hover:text-primary-500 dark:hover:text-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
            aria-label="Email"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </a>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          © {new Date().getFullYear()} Elizabeth Blege. All rights reserved.
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500">
          Built with React + Cursor
        </p>
      </div>
    </footer>
  );
}

export default Footer;
